<a class="block w-32 select-none" (click)="goTo()">
  <img src="assets/logo/mprove_logo_web-01-b.svg" />
</a>
